import { Pipe, PipeTransform } from '@angular/core';
import { GLOBAL_CONSTANT } from '../constants/global.constant';
@Pipe({
  name: 'nameSlice',
})
export class NameSlicePipe implements PipeTransform {
  transform(value: string): string {
    if (value.length < 36) {
      return value;
    } else {
      return (
        value.slice(GLOBAL_CONSTANT.DEFAULT_INITIALIZER, 15) +
        ' ... ' +
        countWord(value.slice(value.length - 16))
      );
    }

    function countWord(s: string): string {
      return s.includes(' ') ? s.substring(s.indexOf(' ') + 1) : s;
    }
  }
}
